import React from "react";
import { Link } from "react-router-dom";

export default function TeamComponent(props) {
  const { item } = props;
  return (
    //  <div className="col-md-2 single-team">
    //    <div className="thumb">
    //      <img className="img-fluid" src={item?.img} alt={item?.title} />
    //      <div className="align-items-center justify-content-center d-flex">
    //        <Link to={item?.link}>
    //          <i className="fa fa-linkedin" />
    //        </Link>
    //      </div>
    //    </div>
    //    <div className="meta-text mt-10 text-center">
    //      {/* <h4>{item?.title}</h4>
    //      <h6>{item?.position}</h6>
    //      <p>{item?.stitle}</p> */}
    //      <p style={{ fontSize: "12px" }}>
    //        <span>{item?.title}</span>
    //        <span style={{ fontSize: "10px" }}>{item?.stitle}</span>
    //        <br />
    //        <span style={{ fontSize: "9px" }}>
    //        {item?.position}
    //        </span>
    //      </p>
    //    </div>
    //  </div>

    <div className="col-md-2 single-team">
      <div className="thumb">
        <img className="img-fluid" src={item?.img} alt={item?.title} />
        <div className="align-items-center justify-content-center d-flex">
          <Link to={item?.link}>
            <i className="fa fa-linkedin" />
          </Link>
        </div>
      </div>
      <div className="meta-text mt-30 text-center">
        <h4>{item?.title}</h4>
        <p>{item?.stitle}</p>
      </div>
    </div>
  );
}
